import classroom from './classroom';
import details from './details';
import latestReleases from './latestReleases';
import course from './course';
import invoices from './invoices';
import memberships from './memberships';
import helpCentre from './helpCentre';
import skills from './skills';
import redirects from './redirects';
import account from './account';
import credential from './credential';
import upsellAnnual from './upsellAnnual'

export default [
    classroom, details, latestReleases,
    course, invoices, memberships, helpCentre,
    skills,
    ...redirects,
    account,
    ...credential,
    ...upsellAnnual
    
];